import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import * as api from '../api';
import {CashflowGroup, CashflowMethodGroup, CompanyRanking, Dokument, Group, Item} from '@/store/models';
import Vue from 'vue';
import user from '@/store/modules/user';
import config from '@/config';

export interface Source {
  BasedOn: string;
  SieAggVersion: number;
}

export interface Branch {
  Bransch: string;
  BranschText: string;
}

export interface Text {
  Type: string;
  Text: string | undefined;
}

@Module({
  namespaced: true,
  name: 'dokument',
  store,
  dynamic: true,
})
class DokumentModule extends VuexModule {
  pending: boolean = false;
  loaded: boolean = false;

  Language: string = 'sv';
  DocumentId: string = '';
  Type: string = '';
  SubType: string = '';
  Version: number = 0;
  OrgNr: string = '';
  AggId: string = '';
  AggVersion: number = 0;
  SieAggVersion: number = 0;
  BasedOn: string = '';
  Bransch: string = '';
  BranschText: string = '';
  Items: Item[] = [];
  Children: number[] = [];
  Competitor1: string = '';
  Competitor2: string = '';
  Texts: any = {};

  overview: any | undefined = null;
  ranking: any | undefined = null;
  profitloss: any | undefined = null;
  balance: any | undefined = null;
  cashflow: any | undefined = null;
  sustainability: any | undefined = null;

  // tslint:disable:max-line-length
  private flexibleGT = {
    Language: 'sv',
    DocumentId: '',
    Type: 'typed',
    SubType: 'flexible',
    Version: 2,
    OrgNr: '',
    AggId: '',
    AggVersion: 0,
    SieAggVersion: 0,
    BasedOn: '',
    Bransch: '',
    BranschText: '',
    Children: [1, 2, 60, 5, 11, 17, 18, 23, 46, 29, 37, 41, 100],
    Competitor1: '',
    Competitor2: '',
    Texts: {},
    Items: [
      {Id: 1, Kind: 'section', Type: 'cover', SubType: 'flexible'} as Item,

      {Id: 2, Kind: 'group', Type: 'intro', Children: [3, 4], Hidden: true} as Group,
      {Id: 3, Kind: 'section', Type: 'agenda', SubType: '', Hidden: true} as Item,
      {Id: 4, Kind: 'section', Type: 'list', SubType: 'custom', Hidden: true} as Item,

      {Id: 60, Kind: 'group', Type: 'schedule', Children: [61], Hidden: true} as Group,
      {Id: 61, Kind: 'section', Type: 'schedule', SubType: '', Hidden: true} as Item,

      {Id: 5, Kind: 'group', Type: 'profitloss', Children: [6, 7, 8, 9, 10], Hidden: true} as Group,
      {Id: 6, Kind: 'section', Type: 'heading', SubType: 'profitloss'} as Item,
      {Id: 7, Kind: 'section', Type: 'chart', SubType: 'profitlossBarTurnoverYears', Hidden: true} as Item,
      {Id: 8, Kind: 'section', Type: 'chart', SubType: 'profitlossBarYears', Hidden: true} as Item,
      {Id: 9, Kind: 'section', Type: 'chart', SubType: 'profitlossWaterfallLatest', Hidden: true} as Item,
      {Id: 10, Kind: 'section', Type: 'table', SubType: 'profitlossYears', Hidden: true} as Item,

      {Id: 11, Kind: 'group', Type: 'balance', Children: [12, 13, 14, 15, 16], Hidden: true} as Group,
      {Id: 12, Kind: 'section', Type: 'heading', SubType: 'balance'} as Item,
      {Id: 13, Kind: 'section', Type: 'chart', SubType: 'balanceBarSolidityYears', Hidden: true} as Item,
      {Id: 14, Kind: 'section', Type: 'chart', SubType: 'balanceBarYears', Hidden: true} as Item,
      {Id: 15, Kind: 'section', Type: 'chart', SubType: 'balanceWaterfallLatest', Hidden: true} as Item,
      {Id: 16, Kind: 'section', Type: 'table', SubType: 'balanceYears', Hidden: true} as Item,

      {Id: 17, Kind: 'group', Type: 'cashflow', Method: 'none', Children: [1000, 2002, 2003, 2004, 2005], Hidden: true} as CashflowGroup,
      {Id: 1000, Kind: 'section', Type: 'heading', SubType: 'cashflow'} as Item,
      {Id: 1001, Kind: 'section', Type: 'list', SubType: 'cashflowMethod1'} as Item,
      {Id: 1002, Kind: 'section', Type: 'list', SubType: 'cashflowMethod2'} as Item,
      {Id: 1003, Kind: 'section', Type: 'list', SubType: 'cashflowMethod3'} as Item,
      {Id: 1004, Kind: 'section', Type: 'list', SubType: 'cashflowMethod4'} as Item,
      {Id: 1005, Kind: 'section', Type: 'list', SubType: 'cashflowMethod5'} as Item,
      {Id: 1006, Kind: 'section', Type: 'list', SubType: 'cashflowMethod6'} as Item,
      {Id: 1007, Kind: 'section', Type: 'list', SubType: 'cashflowMethod7'} as Item,
      {Id: 2002, Kind: 'section', Type: 'chart', SubType: 'cashflowBarYears', Hidden: true} as Item,
      {Id: 2003, Kind: 'section', Type: 'chart', SubType: 'cashflowDoughnutLatest', Hidden: true} as Item,
      {Id: 2004, Kind: 'section', Type: 'chart', SubType: 'cashflowWaterfallLatest', Hidden: true} as Item,
      {Id: 2005, Kind: 'section', Type: 'table', SubType: 'cashflowYears', Hidden: true} as Item,
      {Id: 2007, Kind: 'section', Type: 'list', SubType: 'cashflowRecommendation_none', Hidden: true} as Item,

      {Id: 18, Kind: 'group', Type: 'yearend', Children: [19, 20, 21, 22], Hidden: true} as Group,
      {Id: 19, Kind: 'section', Type: 'heading', SubType: 'yearend'} as Item,
      {Id: 20, Kind: 'section', Type: 'list', SubType: 'yearendNotes', Hidden: true} as Item,
      {Id: 21, Kind: 'section', Type: 'list', SubType: 'yearendCovid', Hidden: true} as Item,
      {Id: 22, Kind: 'section', Type: 'image', SubType: 'yearendSigning', Hidden: true} as Item,

      {Id: 23, Kind: 'group', Type: 'compass', Children: [24, 25, 26, 27, 28], Hidden: true} as Group,
      {Id: 24, Kind: 'section', Type: 'heading', SubType: 'compass'} as Item,
      {Id: 25, Kind: 'section', Type: 'compass', SubType: 'latest', Hidden: true} as Item,
      {Id: 26, Kind: 'section', Type: 'comment', SubType: 'compass', Hidden: true} as Item,
      {Id: 27, Kind: 'section', Type: 'compass', SubType: 'years', Hidden: true} as Item,
      {Id: 28, Kind: 'section', Type: 'compass', SubType: 'industry', Hidden: true} as Item,

      {Id: 46, Kind: 'group', Type: 'sustainability', Children: [47, 50, 51, 52, 48, 49], Hidden: true} as Group,
      {Id: 47, Kind: 'section', Type: 'heading', SubType: 'sustainability'} as Item,
      {Id: 50, Kind: 'section', Type: 'chart', SubType: 'sustainabilityImpact', Hidden: true} as Item,
      {Id: 51, Kind: 'section', Type: 'chart', SubType: 'sustainabilityQuestions', Hidden: true} as Item,
      {Id: 52, Kind: 'section', Type: 'chart', SubType: 'sustainabilityProcess', Hidden: true} as Item,
      {Id: 48, Kind: 'section', Type: 'compass', SubType: 'sustainability', Hidden: true} as Item,
      {Id: 49, Kind: 'section', Type: 'list', SubType: 'sustainability', Hidden: true} as Item,

      {Id: 29, Kind: 'group', Type: 'competition', Children: [30, 31, 32, 33, 34, 35, 36], Hidden: true} as Group,
      {Id: 30, Kind: 'section', Type: 'heading', SubType: 'competition'} as Item,
      {Id: 31, Kind: 'section', Type: 'competitors', SubType: ''} as Item,
      {Id: 32, Kind: 'section', Type: 'chart', SubType: 'competitionBarTurnoverYears', Hidden: true} as Item,
      {Id: 33, Kind: 'section', Type: 'chart', SubType: 'competitionBarProfitlossLatest', Hidden: true} as Item,
      {Id: 34, Kind: 'section', Type: 'chart', SubType: 'competitionBarBalanceYears', Hidden: true} as Item,
      {Id: 35, Kind: 'section', Type: 'chart', SubType: 'competitionBarBalanceLatest', Hidden: true} as Item,
      {Id: 36, Kind: 'section', Type: 'compass', SubType: 'competitionLatest', Hidden: true} as Item,

      {Id: 37, Kind: 'group', Type: 'gtAdvisory', Children: [38, 39, 40], Hidden: true} as Group,
      {Id: 38, Kind: 'section', Type: 'heading', SubType: 'gtAdvisory'} as Item,
      {Id: 39, Kind: 'section', Type: 'image', SubType: 'gtAdvisoryYourjourney', Hidden: true} as Item,
      {Id: 40, Kind: 'section', Type: 'image', SubType: 'gtAdvisoryHouse', Hidden: true} as Item,

      {Id: 41, Kind: 'group', Type: 'completion', Children: [42, 43, 44, 45], Hidden: true} as Group,
      {Id: 42, Kind: 'section', Type: 'heading', SubType: 'completion'} as Item,
      {Id: 43, Kind: 'section', Type: 'list', SubType: 'completion', Hidden: true} as Item,
      {Id: 44, Kind: 'section', Type: 'image', SubType: 'completionFeedback', Hidden: true} as Item,
      {Id: 45, Kind: 'section', Type: 'image', SubType: 'completionNextmeeting', Hidden: true} as Item,

      {Id: 100, Kind: 'section', Type: 'liability', SubType: ''} as Item,

      // {Id: 5000, Kind: 'group', Type: 'custom_list', Children: [5001], Hidden: false} as Group,
      // {Id: 5001, Kind: 'section', Type: 'list', SubType: 'custom', Hidden: true} as Item,
      // {Id: 5002, Kind: 'group', Type: 'custom_image', Children: [5003], Hidden: false} as Group,
      // {Id: 5003, Kind: 'section', Type: 'image', SubType: 'custom', Hidden: true} as Item,
    ],
  };

  // tslint:disable:max-line-length
  private flexibleBK = {
    Language: 'sv',
    DocumentId: '',
    Type: 'typed',
    SubType: 'flexible',
    Version: 1,
    OrgNr: '',
    AggId: '',
    AggVersion: 0,
    SieAggVersion: 0,
    BasedOn: '',
    Bransch: '',
    BranschText: '',
    Children: [1, 2, 5, 11, 17, 18, 23, 46, 29, 100],
    Competitor1: '',
    Competitor2: '',
    Texts: {},
    Items: [
      {Id: 1, Kind: 'section', Type: 'cover', SubType: 'flexible'} as Item,

      {Id: 2, Kind: 'group', Type: 'intro', Children: [3, 4], Hidden: true} as Group,
      {Id: 3, Kind: 'section', Type: 'agenda', SubType: '', Hidden: true} as Item,
      {Id: 4, Kind: 'section', Type: 'list', SubType: 'custom', Hidden: true} as Item,

      {Id: 5, Kind: 'group', Type: 'profitloss', Children: [6, 7, 8, 9, 10], Hidden: true} as Group,
      {Id: 6, Kind: 'section', Type: 'heading', SubType: 'profitloss'} as Item,
      {Id: 7, Kind: 'section', Type: 'chart', SubType: 'profitlossBarTurnoverYears', Hidden: true} as Item,
      {Id: 8, Kind: 'section', Type: 'chart', SubType: 'profitlossBarYears', Hidden: true} as Item,
      {Id: 9, Kind: 'section', Type: 'chart', SubType: 'profitlossWaterfallLatest', Hidden: true} as Item,
      {Id: 10, Kind: 'section', Type: 'table', SubType: 'profitlossYears', Hidden: true} as Item,

      {Id: 11, Kind: 'group', Type: 'balance', Children: [12, 13, 14, 15, 16], Hidden: true} as Group,
      {Id: 12, Kind: 'section', Type: 'heading', SubType: 'balance'} as Item,
      {Id: 13, Kind: 'section', Type: 'chart', SubType: 'balanceBarSolidityYears', Hidden: true} as Item,
      {Id: 14, Kind: 'section', Type: 'chart', SubType: 'balanceBarYears', Hidden: true} as Item,
      {Id: 15, Kind: 'section', Type: 'chart', SubType: 'balanceWaterfallLatest', Hidden: true} as Item,
      {Id: 16, Kind: 'section', Type: 'table', SubType: 'balanceYears', Hidden: true} as Item,

      {
        Id: 17,
        Kind: 'group',
        Type: 'cashflow',
        Method: 'none',
        Children: [1000, 2002, 2003, 2004, 2005],
        Hidden: true,
      } as CashflowGroup,
      {Id: 1000, Kind: 'section', Type: 'heading', SubType: 'cashflow'} as Item,
      {Id: 1001, Kind: 'section', Type: 'list', SubType: 'cashflowMethod1'} as Item,
      {Id: 1002, Kind: 'section', Type: 'list', SubType: 'cashflowMethod2'} as Item,
      {Id: 1003, Kind: 'section', Type: 'list', SubType: 'cashflowMethod3'} as Item,
      {Id: 1004, Kind: 'section', Type: 'list', SubType: 'cashflowMethod4'} as Item,
      {Id: 1005, Kind: 'section', Type: 'list', SubType: 'cashflowMethod5'} as Item,
      {Id: 1006, Kind: 'section', Type: 'list', SubType: 'cashflowMethod6'} as Item,
      {Id: 1007, Kind: 'section', Type: 'list', SubType: 'cashflowMethod7'} as Item,
      {Id: 2002, Kind: 'section', Type: 'chart', SubType: 'cashflowBarYears', Hidden: true} as Item,
      {Id: 2003, Kind: 'section', Type: 'chart', SubType: 'cashflowDoughnutLatest', Hidden: true} as Item,
      {Id: 2004, Kind: 'section', Type: 'chart', SubType: 'cashflowWaterfallLatest', Hidden: true} as Item,
      {Id: 2005, Kind: 'section', Type: 'table', SubType: 'cashflowYears', Hidden: true} as Item,
      {Id: 2007, Kind: 'section', Type: 'list', SubType: 'cashflowRecommendation_none', Hidden: true} as Item,

      {Id: 18, Kind: 'group', Type: 'yearend', Children: [19, 20, 21, 22], Hidden: true} as Group,
      {Id: 19, Kind: 'section', Type: 'heading', SubType: 'yearend'} as Item,
      {Id: 20, Kind: 'section', Type: 'list', SubType: 'yearendNotes', Hidden: true} as Item,
      {Id: 21, Kind: 'section', Type: 'list', SubType: 'yearendCovid', Hidden: true} as Item,
      {Id: 22, Kind: 'section', Type: 'image', SubType: 'yearendSigning', Hidden: true} as Item,

      {Id: 23, Kind: 'group', Type: 'compass', Children: [24, 25, 26, 27, 28], Hidden: true} as Group,
      {Id: 24, Kind: 'section', Type: 'heading', SubType: 'compass'} as Item,
      {Id: 25, Kind: 'section', Type: 'compass', SubType: 'latest', Hidden: true} as Item,
      {Id: 26, Kind: 'section', Type: 'comment', SubType: 'compass', Hidden: true} as Item,
      {Id: 27, Kind: 'section', Type: 'compass', SubType: 'years', Hidden: true} as Item,
      {Id: 28, Kind: 'section', Type: 'compass', SubType: 'industry', Hidden: true} as Item,

      {Id: 46, Kind: 'group', Type: 'sustainability', Children: [47, 48, 49], Hidden: true} as Group,
      {Id: 47, Kind: 'section', Type: 'heading', SubType: 'sustainability'} as Item,
      {Id: 48, Kind: 'section', Type: 'compass', SubType: 'sustainability', Hidden: true} as Item,
      {Id: 49, Kind: 'section', Type: 'list', SubType: 'sustainability', Hidden: true} as Item,

      {Id: 29, Kind: 'group', Type: 'competition', Children: [30, 31, 32, 33, 34, 35, 36], Hidden: true} as Group,
      {Id: 30, Kind: 'section', Type: 'heading', SubType: 'competition'} as Item,
      {Id: 31, Kind: 'section', Type: 'competitors', SubType: ''} as Item,
      {Id: 32, Kind: 'section', Type: 'chart', SubType: 'competitionBarTurnoverYears', Hidden: true} as Item,
      {Id: 33, Kind: 'section', Type: 'chart', SubType: 'competitionBarProfitlossLatest', Hidden: true} as Item,
      {Id: 34, Kind: 'section', Type: 'chart', SubType: 'competitionBarBalanceYears', Hidden: true} as Item,
      {Id: 35, Kind: 'section', Type: 'chart', SubType: 'competitionBarBalanceLatest', Hidden: true} as Item,
      {Id: 36, Kind: 'section', Type: 'compass', SubType: 'competitionLatest', Hidden: true} as Item,

      {Id: 100, Kind: 'section', Type: 'liability', SubType: ''} as Item,

      // {Id: 5000, Kind: 'group', Type: 'custom_list', Children: [5001], Hidden: false} as Group,
      // {Id: 5001, Kind: 'section', Type: 'list', SubType: 'custom', Hidden: true} as Item,
      // {Id: 5002, Kind: 'group', Type: 'custom_image', Children: [5003], Hidden: false} as Group,
      // {Id: 5003, Kind: 'section', Type: 'image', SubType: 'custom', Hidden: true} as Item,
    ],
  };

  get getItems(): (x: number) => Item[] {
    return ((parent: number) => {
      let children: number[] = [];
      if (parent === 0) {
        children = this.Children;
      } else {
        children = (this.Items.find((x) => x.Id === parent) as Group).Children;
      }
      return children.map((id: number) => this.Items.find((x) => x.Id === id) as Item);
      // this.Items.filter((x) => children.includes(x.Id));
    });
  }

  get getItem(): (x: number) => Item {
    return ((parent: number) => {
      return this.Items.filter((x) => x.Id === parent)[0];
    });
  }

  @Action({rawError: true})
  async loadDocument(documentId: string) {
    this.setLoaded(false);
    this.setPending(true);
    this.setDocument(await api.getDocumentPlain(documentId) as Dokument);
    this.setPending(false);
    this.setLoaded(true);
  }

  @Action({rawError: true})
  async loadData() {
    if (this.SieAggVersion > 0) {
      await this.setRanking(await api.getRankingSie(this.SieAggVersion, this.OrgNr));
      await this.setProfitloss(await api.getProfitLossSie(this.SieAggVersion, this.OrgNr));
      await this.setBalance(await api.getBalanceSie(this.SieAggVersion, this.OrgNr));
      await this.setCashflow(await api.getCashFlowSie(this.SieAggVersion, this.OrgNr));
    } else {
      await this.setRanking(await api.getRanking(user.version, this.OrgNr));
      await this.setProfitloss(await api.getProfitLoss(user.version, this.OrgNr));
      await this.setBalance(await api.getBalance(user.version, this.OrgNr));
      await this.setCashflow(await api.getCashFlow(user.version, this.OrgNr));
    }
    await this.setSustainability(await api.getSustainability(user.version, this.OrgNr));
    await this.setOverview(await api.getOverview(user.version, this.OrgNr));
  }

  @Action
  initEmpty() {
    this.setLoaded(false);
    this.setCompany('');
    this.setDocument({
      Language: 'sv',
      DocumentId: '',
      Type: 'typed',
      SubType: 'empty',
      Version: 1,
      OrgNr: '',
      AggId: '',
      AggVersion: 0,
      SieAggVersion: 0,
      BasedOn: '',
      Bransch: '',
      BranschText: '',
      Children: [],
      Competitor1: '',
      Competitor2: '',
      Texts: {},
      Items: [],
    });
    this.setLoaded(true);
  }

  @Action
  initFlexible() {
    this.setLoaded(false);
    this.setCompany('');
    switch (config.brand) {
      case 'GT':
        this.setDocument(this.flexibleGT);
        break;
      case 'BK':
        this.setDocument(this.flexibleBK);
        break;
    }
    this.setLoaded(true);
  }


  @Action
  add(type: string) {
    const id = this.Items.reduce((p, v) => (p.Id > v.Id ? p : v)).Id + 1;
    let start = 2;

    if (this.SubType === 'cashflow' || this.SubType === 'company') {
      start = 1;
    }

    switch (type) {
      case 'custom_list':
        this.Items.push({Id: id, Kind: 'group', Type: 'custom_list', Children: [id + 1], Hidden: false} as Group);
        this.Items.push({Id: id + 1, Kind: 'section', Type: 'list', SubType: 'custom', Hidden: true} as Item);
        this.Children.splice(start, 0, id);
        break;
      case 'custom_image':
        this.Items.push({Id: id, Kind: 'group', Type: 'custom_image', Children: [id + 1], Hidden: false} as Group);
        this.Items.push({Id: id + 1, Kind: 'section', Type: 'image', SubType: 'custom', Hidden: true} as Item);
        this.Children.splice(start, 0, id);
        break;
    }
  }

  @Action
  initCashflow() {
    this.setLoaded(false);
    this.setCompany('');
    this.setDocument({
      Language: 'sv',
      DocumentId: '',
      Type: 'typed',
      SubType: 'cashflow',
      Version: 2,
      OrgNr: '',
      AggId: '',
      AggVersion: 0,
      SieAggVersion: 0,
      BasedOn: '',
      Bransch: '',
      BranschText: '',
      Children: [1, 4, 5, 8],
      Competitor1: '',
      Competitor2: '',
      Texts: {},
      Items: [
        {Id: 1, Kind: 'section', Type: 'cover', SubType: 'cashflow'} as Item,
        {Id: 4, Kind: 'group', Type: 'cashflow_method', SubType: '', Children: []} as Group,
        {Id: 5, Kind: 'group', Type: 'cashflow_analysis', SubType: '', Children: []} as Item,
        {Id: 8, Kind: 'section', Type: 'liability', SubType: ''} as Item,
        {Id: 1001, Kind: 'section', Type: 'list', SubType: 'cashflowMethod1'} as Item,
        {Id: 1002, Kind: 'section', Type: 'list', SubType: 'cashflowMethod2'} as Item,
        {Id: 1003, Kind: 'section', Type: 'list', SubType: 'cashflowMethod3'} as Item,
        {Id: 1004, Kind: 'section', Type: 'list', SubType: 'cashflowMethod4'} as Item,
        {Id: 1005, Kind: 'section', Type: 'list', SubType: 'cashflowMethod5'} as Item,
        {Id: 1006, Kind: 'section', Type: 'list', SubType: 'cashflowMethod6'} as Item,
        {Id: 1007, Kind: 'section', Type: 'list', SubType: 'cashflowMethod7'} as Item,
        {Id: 1008, Kind: 'section', Type: 'image', SubType: 'cashflowExample'} as Item,
        {Id: 2001, Kind: 'section', Type: 'company_name', SubType: ''} as Item,
        {Id: 2008, Kind: 'section', Type: 'chart', SubType: 'balanceBarCashYears'} as Item,
        {Id: 2002, Kind: 'section', Type: 'chart', SubType: 'cashflowyears'} as Item,
        {Id: 2003, Kind: 'section', Type: 'chart', SubType: 'cashflowdaytoday'} as Item,
        {Id: 2004, Kind: 'section', Type: 'chart', SubType: 'cashflow'} as Item,
        {Id: 2005, Kind: 'section', Type: 'chart', SubType: 'cashflowtable'} as Item,
        {Id: 2006, Kind: 'section', Type: 'list', SubType: 'cashflowRecommendation'} as Item,
        {Id: 2007, Kind: 'section', Type: 'list', SubType: 'cashflowRecommendation_none'} as Item,
      ],
    });
    this.setLoaded(true);
  }

  @Action
  initWebreportCashflow() {
    this.setLoaded(false);
    this.setCompany('');
    this.setDocument({
      Language: 'sv',
      DocumentId: '',
      Type: 'typed',
      SubType: 'webreport_cashflow',
      Version: 1,
      OrgNr: '',
      AggId: '',
      AggVersion: 0,
      SieAggVersion: 0,
      BasedOn: '',
      Bransch: '',
      BranschText: '',
      Children: [],
      Competitor1: '',
      Competitor2: '',
      Texts: {},
      Items: [],
    });
    this.setLoaded(true);
  }

  @Action
  initCompany() {
    this.setLoaded(false);
    this.setCompany('');
    this.setDocument({
      Language: 'sv',
      DocumentId: '',
      Type: 'typed',
      SubType: 'company',
      Version: 1,
      OrgNr: '',
      AggId: '',
      AggVersion: 0,
      SieAggVersion: 0,
      BasedOn: '',
      Bransch: '',
      BranschText: '',
      Children: [1, 2, 100],
      Competitor1: '',
      Competitor2: '',
      Texts: {},
      Items: [
        {Id: 1, Kind: 'section', Type: 'cover', SubType: 'company'} as Item,
        {Id: 2, Kind: 'group', Type: 'company', SubType: '',
          Children: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]} as Group,
        {Id: 3, Kind: 'section', Type: 'list', SubType: 'company_agenda'} as Item,
        {Id: 4, Kind: 'section', Type: 'heading', SubType: 'overview'} as Item,
        {Id: 5, Kind: 'section', Type: 'chart', SubType: 'profitloss'} as Item,
        {Id: 6, Kind: 'section', Type: 'chart', SubType: 'balance'} as Item,
        {Id: 7, Kind: 'section', Type: 'heading', SubType: 'profitloss'} as Item,
        {Id: 8, Kind: 'section', Type: 'chart', SubType: 'profitlossdiagram'} as Item,
        {Id: 9, Kind: 'section', Type: 'chart', SubType: 'profitlossyears'} as Item,
        {Id: 10, Kind: 'section', Type: 'heading', SubType: 'balance'} as Item,
        {Id: 11, Kind: 'section', Type: 'chart', SubType: 'balancediagram'} as Item,
        {Id: 12, Kind: 'section', Type: 'chart', SubType: 'balanceyears'} as Item,
        {Id: 13, Kind: 'section', Type: 'heading', SubType: 'compass'} as Item,
        {Id: 14, Kind: 'section', Type: 'compass', SubType: 'latest'} as Item,
        {Id: 15, Kind: 'section', Type: 'compass', SubType: 'years'} as Item,
        {Id: 16, Kind: 'section', Type: 'comment', SubType: 'compass', Hidden: false} as Item,
        {Id: 100, Kind: 'section', Type: 'liability', SubType: ''} as Item,
      ],
    });
    this.setLoaded(true);
  }

  @Action
  initIndustryAnalysis() {
    this.setLoaded(false);
    this.setCompany('');
    this.setDocument({
      Language: 'sv',
      DocumentId: '',
      Type: 'typed',
      SubType: 'industryAnalysis',
      Version: 1,
      OrgNr: '',
      AggId: '',
      AggVersion: 0,
      SieAggVersion: 0,
      BasedOn: '',
      Bransch: '',
      BranschText: '',
      Children: [1, 2, 600, 601, 602, 100],
      Competitor1: '',
      Competitor2: '',
      Texts: {},
      Items: [
        {Id: 1, Kind: 'section', Type: 'cover', SubType: 'industryAnalysis'} as Item,
        {Id: 2, Kind: 'group', Type: 'industryAnalysis', SubType: '', Children: [3, 39, 4, 5, 59, 6, 500]} as Group,
        {Id: 3, Kind: 'section', Type: 'list', SubType: 'industryAnalysisAgenda', Hidden: false} as Item,
        {Id: 39, Kind: 'section', Type: 'heading', SubType: 'analysis_conditions'} as Item,
        {Id: 4, Kind: 'section', Type: 'list', SubType: 'industryAnalysisConditions', Hidden: false} as Item,
        {Id: 5, Kind: 'section', Type: 'list', SubType: 'industryAnalysisCompassInfo', Hidden: false} as Item,
        {Id: 59, Kind: 'section', Type: 'heading', SubType: 'analysis_analysis'} as Item,
        {Id: 6, Kind: 'section', Type: 'extendedCompass', SubType: 'industry'} as Item,
        {Id: 500, Kind: 'section', Type: 'list', SubType: 'impressions', Hidden: false} as Item,
        {Id: 100, Kind: 'section', Type: 'liability', SubType: ''} as Item,

        {Id: 600, Kind: 'group', Type: 'analysis_summary', SubType: '', Category: 'summary', Children: [700, 701]} as Group,
        {Id: 601, Kind: 'group', Type: 'analysis_nextstep', SubType: '', Category: 'summary', Children: [710, 711]} as Group,
        {Id: 602, Kind: 'group', Type: 'analysis_info', SubType: '', Category: 'summary', Children: [720]} as Group,
        {Id: 700, Kind: 'section', Type: 'heading', SubType: 'analysis_summary'} as Item,
        {Id: 701, Kind: 'section', Type: 'analysis_summary', SubType: '', Hidden: true, PrintOnly: true} as Item,
        {Id: 710, Kind: 'section', Type: 'heading', SubType: 'analysis_nextstep'} as Item,
        {Id: 711, Kind: 'section', Type: 'analysis_nextstep', SubType: '', Hidden: true, PrintOnly: true} as Item,
        {Id: 720, Kind: 'section', Type: 'analysis_info', SubType: '', Hidden: true, PrintOnly: true} as Item,
      ],
    });
    this.setLoaded(true);
  }

  @Action
  initCompetitorAnalysis() {
    this.setLoaded(false);
    this.setCompany('');
    this.setDocument({
      Language: 'sv',
      DocumentId: '',
      Type: 'typed',
      SubType: 'competitorAnalysis',
      Version: 1,
      OrgNr: '',
      AggId: '',
      AggVersion: 0,
      SieAggVersion: 0,
      BasedOn: '',
      Bransch: '',
      BranschText: '',
      Children: [1, 2, 600, 601, 602, 100],
      Competitor1: '',
      Competitor2: '',
      Texts: {},
      Items: [
        {Id: 1, Kind: 'section', Type: 'cover', SubType: 'competitorAnalysis'} as Item,
        {Id: 2, Kind: 'group', Type: 'competitorAnalysis', SubType: '', Children: [3, 39, 4, 5, 59, 6, 500]} as Group,
        {Id: 3, Kind: 'section', Type: 'list', SubType: 'competitorAnalysisAgenda', Hidden: false} as Item,
        {Id: 39, Kind: 'section', Type: 'heading', SubType: 'analysis_conditions'} as Item,
        {Id: 4, Kind: 'section', Type: 'list', SubType: 'competitorAnalysisConditions', Hidden: false} as Item,
        {Id: 5, Kind: 'section', Type: 'list', SubType: 'competitorAnalysisCompassInfo', Hidden: false} as Item,
        {Id: 59, Kind: 'section', Type: 'heading', SubType: 'analysis_analysis'} as Item,
        {Id: 6, Kind: 'section', Type: 'extendedCompass', SubType: 'competitionLatest'} as Item,
        {Id: 500, Kind: 'section', Type: 'list', SubType: 'impressions', Hidden: false} as Item,
        {Id: 100, Kind: 'section', Type: 'liability', SubType: ''} as Item,

        {Id: 600, Kind: 'group', Type: 'analysis_summary', SubType: '', Category: 'summary', Children: [700, 701]} as Group,
        {Id: 601, Kind: 'group', Type: 'analysis_nextstep', SubType: '', Category: 'summary', Children: [710, 711]} as Group,
        {Id: 602, Kind: 'group', Type: 'analysis_info', SubType: '', Category: 'summary', Children: [720]} as Group,
        {Id: 700, Kind: 'section', Type: 'heading', SubType: 'analysis_summary'} as Item,
        {Id: 701, Kind: 'section', Type: 'analysis_summary', SubType: '', Hidden: false, PrintOnly: true} as Item,
        {Id: 710, Kind: 'section', Type: 'heading', SubType: 'analysis_nextstep'} as Item,
        {Id: 711, Kind: 'section', Type: 'analysis_nextstep', SubType: '', Hidden: false, PrintOnly: true} as Item,
        {Id: 720, Kind: 'section', Type: 'analysis_info', SubType: '', Hidden: false, PrintOnly: true} as Item,
      ],
    });
    this.setLoaded(true);
  }

  @Action
  initPreClosingMeeting() {
    this.setLoaded(false);
    this.setCompany('');
    this.setDocument({
      Language: 'sv',
      DocumentId: '',
      Type: 'typed',
      SubType: 'preClosingMeeting',
      Version: 1,
      OrgNr: '',
      AggId: '',
      AggVersion: 0,
      SieAggVersion: 0,
      BasedOn: '',
      Bransch: '',
      BranschText: '',
      Children: [1, 7, 2, 3, 4, 5, 6, 8, 9, 100],
      Competitor1: '',
      Competitor2: '',
      Texts: {},
      Items: [
        {Id: 1, Kind: 'section', Type: 'cover', SubType: 'preClosingMeeting'} as Item,

        {Id: 7, Kind: 'group', Type: 'preClosingMeeting_intro', Children: [1499]} as Group,
        {Id: 1499, Kind: 'section', Type: 'agenda', SubType: ''} as Item,

        {Id: 2, Kind: 'group', Type: 'preClosingMeeting_thisYear', SubType: '', Children: [1500, 1501, 1502, 1503, 1504, 1513]} as Group,
        {Id: 1500, Kind: 'section', Type: 'heading', SubType: 'preClosingMeeting_thisYear'} as Item,
        {Id: 1501, Kind: 'section', Type: 'chart', SubType: 'profitlossGT'} as Item,
        {Id: 1502, Kind: 'section', Type: 'chart', SubType: 'profitlossdiagram'} as Item,
        {Id: 1503, Kind: 'section', Type: 'chart', SubType: 'balanceGT'} as Item,
        {Id: 1504, Kind: 'section', Type: 'chart', SubType: 'balancediagram'} as Item,
        {Id: 1513, Kind: 'section', Type: 'list', SubType: 'preClosingMeeting_thisYear'} as Item,

        {Id: 3, Kind: 'group', Type: 'preClosingMeeting_remaining', SubType: '', Children: [1505, 1506], Hidden: true} as Group,
        {Id: 1505, Kind: 'section', Type: 'heading', SubType: 'preClosingMeeting_remaining'} as Item,
        {Id: 1506, Kind: 'section', Type: 'list', SubType: 'preClosingMeeting_remaining'} as Item,

        {Id: 4, Kind: 'group', Type: 'preClosingMeeting_future', SubType: '', Children: [1507]} as Group,
        {Id: 1507, Kind: 'section', Type: 'heading', SubType: 'preClosingMeeting_future'} as Item,

        {Id: 5, Kind: 'group', Type: 'preClosingMeeting_schedule', SubType: '', Children: [1509, 61]} as Group,
        {Id: 1509, Kind: 'section', Type: 'heading', SubType: 'preClosingMeeting_schedule'} as Item,
        {Id: 61, Kind: 'section', Type: 'schedule', SubType: '', Hidden: false} as Item,

        {Id: 6, Kind: 'group', Type: 'preClosingMeeting_misc', SubType: '', Children: [1511, 1512], Hidden: true} as Group,
        {Id: 1511, Kind: 'section', Type: 'heading', SubType: 'preClosingMeeting_misc'} as Item,
        {Id: 1512, Kind: 'section', Type: 'list', SubType: 'preClosingMeeting_misc'} as Item,

        {Id: 8, Kind: 'group', Type: 'preClosingMeeting_feedback', SubType: '', Children: [1514]} as Group,
        {Id: 1514, Kind: 'section', Type: 'heading', SubType: 'preClosingMeeting_feedback'} as Item,

        {Id: 9, Kind: 'group', Type: 'preClosingMeeting_nextMeeting', SubType: '', Children: [1515]} as Group,
        {Id: 1515, Kind: 'section', Type: 'heading', SubType: 'preClosingMeeting_nextMeeting'} as Item,

        {Id: 100, Kind: 'section', Type: 'liability', SubType: ''} as Item,
      ],
    });
    this.setLoaded(true);
  }

  @Action
  async saveDocument(documentId: string) {
    const doc: Dokument = {
      DocumentId: documentId,
      Language: this.Language,
      Type: this.Type,
      SubType: this.SubType,
      Version: this.Version,
      OrgNr: this.OrgNr,
      AggId: this.AggId,
      AggVersion: this.AggVersion,
      SieAggVersion: this.SieAggVersion,
      BasedOn: this.BasedOn,
      Bransch: this.Bransch,
      BranschText: this.BranschText,
      Children: this.Children,
      Items: this.Items,
      Competitor1: this.Competitor1,
      Competitor2: this.Competitor2,
      Texts: this.Texts,
    };
    if (doc.DocumentId) {
      // console.log('update');
      await api.updateDocument(doc);
    } else {
      // console.log('create');
      await api.addDocument(doc);
    }
  }

  get canSaveDocument() {
    return this.OrgNr !== '' && this.OrgNr !== undefined && this.OrgNr !== null;
  }

  @Mutation
  setDocument(doc: Dokument) {
    this.Children = [];
    this.Items.splice(0, this.Items.length);

    this.Language = doc.Language;
    this.DocumentId = doc.DocumentId;
    this.Type = doc.Type;
    this.SubType = doc.SubType;
    this.OrgNr = doc.OrgNr;
    this.AggId = doc.AggId;
    this.AggVersion = doc.AggVersion;
    this.SieAggVersion = doc.SieAggVersion;
    this.BasedOn = doc.BasedOn;
    this.Bransch = doc.Bransch;
    this.BranschText = doc.BranschText;

    for (const item of doc.Items) {
      this.Items.push(item);
    }
    this.Children = doc.Children;
    this.Competitor1 = doc.Competitor1;
    this.Competitor2 = doc.Competitor2;

    Object.assign(this, {overview: undefined});
    Object.assign(this, {ranking: undefined});
    Object.assign(this, {profitloss: undefined});
    Object.assign(this, {balance: undefined});
    Object.assign(this, {cashflow: undefined});
    Object.assign(this, {sustainability: undefined});
    Object.assign(this, {Texts: doc.Texts});

    // console.log('loaded', this.Items);
  }

  @Mutation
  setOverview(overview: any | undefined) {
    this.overview = Object.assign({}, this.overview, overview);
  }

  @Mutation
  setRanking(ranking: any | undefined) {
    this.ranking = Object.assign({}, this.ranking, ranking);
  }

  @Mutation
  setProfitloss(profitloss: any | undefined) {
    this.profitloss = Object.assign({}, this.profitloss, profitloss);
  }

  @Mutation
  setBalance(balance: any | undefined) {
    this.balance = Object.assign({}, this.balance, balance);
  }

  @Mutation
  setCashflow(cashflow: any | undefined) {
    this.cashflow = Object.assign({}, this.cashflow, cashflow);
  }

  @Mutation
  setSustainability(sustainability: any | undefined) {
    this.sustainability = Object.assign({}, this.sustainability, sustainability);
  }

  @Mutation
  setPending(pending: boolean) {
    this.pending = pending;
  }

  @Mutation
  setLoaded(loaded: boolean) {
    this.loaded = loaded;
  }

  @Mutation
  setLangugage(language: string) {
    this.Language = language;
  }

  @Mutation
  setCompany(orgnr: string) {
    this.OrgNr = orgnr;
    Object.assign(this, {ranking: undefined});
    Object.assign(this, {profitloss: undefined});
    Object.assign(this, {balance: undefined});
    Object.assign(this, {cashflow: undefined});
    Object.assign(this, {sustainability: undefined});
  }

  @Mutation
  setSource(source: Source) {
    this.BasedOn = source.BasedOn;
    this.SieAggVersion = source.SieAggVersion;
  }

  @Mutation
  setBranch(branch: Branch) {
    this.Bransch = branch.Bransch;
    this.BranschText = branch.BranschText;
  }

  @Mutation
  setText(text: Text) {
    if (this.Texts[text.Type] === text.Text) {
      return;
    }
    // console.log('setText:', this.Texts[text.Type], text.Type, text.Text, text.Text === undefined);
    const o: any = {};
    o[text.Type] = text.Text;
    this.Texts = Object.assign({}, this.Texts, o);
  }

  @Mutation
  setCompetitor1(orgnr: string) {
    this.Competitor1 = orgnr;
  }

  @Mutation
  setCompetitor2(orgnr: string) {
    this.Competitor2 = orgnr;
  }

  @Mutation
  updateItem(item: Item) {
    // console.log('update', item);

    const i = this.Items.findIndex((x) => x.Id === item.Id);
    Vue.set(this.Items, i, item);
  }

  @Mutation
  moveItem(move: any) {
    const source = move.source;
    let target = move.target;

    if (target < source) {
      target = target + 1;
    }

    // tslint:disable-next-line:max-line-length
    if (source === target || source < 0 || target < 0 || source > this.Children.length || target > this.Children.length) {
      return;
    }

    const old = this.Children[source];
    if (source < target) {
      for (let i = source; i < target; i++) {
        this.Children[i] = this.Children[i + 1];
      }
    } else {
      for (let i = source; i > target; i--) {
        this.Children[i] = this.Children[i - 1];
      }
    }
    this.Children[target] = old;

    for (let i = 0; i < this.Children.length; i++) {
      Vue.set(this.Children, i, this.Children[i]);
    }
  }
}

export default getModule(DokumentModule);
